<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row>
        <v-col cols="12" md="4">
          <AutocompleteAcademicLevel
            v-model="academicLevels"
            clear-icon="mdi-close"
            label="Bộ môn"
            outlined
            dense
            hide-details
            @change="academicLevelChanged"
            multiple
          />
        </v-col>
        <v-col cols="12" md="4">
          <AutocompleteTeacherCard
            :syncedValue.sync="teacher"
            item-text="name"
            clear-icon="mdi-close"
            label="Giáo viên"
            outlined
            dense
            deletable-chips
            hide-details
            :displaySubjectGroup="true"
            :filter="teacherFilter"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="status"
            item-text="title"
            item-value="value"
            label="Trạng thái"
            :items="teacherStatus"
            outlined
            clearable
            dense
            hide-details
          ></v-select>
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
    </div>
  </div>
</template>

<script>
import get from 'lodash-es/get'
import { mapGetters } from 'vuex'
import AutocompleteAcademicLevel from '@/components/basic/input/AutocompleteAcademicLevel.vue'
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard'

export default {
  components: {
    AutocompleteAcademicLevel,
    AutocompleteTeacherCard,
  },
  data: () => ({
    dialog: false,
    name: '',
    code: '',
    status: '',
    windowWidth: window.innerWidth,
    academicLevels: [],
    teacher: null,
  }),
  computed: {
    ...mapGetters('constant', ['teacherStatus']),
    teacherFilter() {
      if (Array.isArray(this.academicLevels) && this.academicLevels.length) {
        return {
          academicLevels_in: this.academicLevels.map((a) => a.id),
        }
      }

      return {}
    },
  },
  methods: {
    academicLevelChanged(academicLevels) {
      this.academicLevels = academicLevels
      this.teacher = null
    },
    onFilterChanged() {
      this.$emit('onFilterChanged', {
        id: get(this.teacher, 'id'),
        status: this.status,
        academicLevels_in: this.academicLevels.map((a) => a.id),
      })
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    clearInterval(this.interval)
  },
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
